import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import QRCode from 'qrcode.react';

import { requestOTP } from '../../common/fetch';
import { UserAction } from '../../actions'
import WrappedOTPForm from './OTPForm';
import { connect } from 'react-redux';
import { Wrapper } from './style';

class TwoFactor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        }
    }
    componentDidMount() {
        const { otp_enabled } = this.props.user
        if (!otp_enabled) {
            this.handleTwoFactor()
        }
    }
    componentDidUpdate(prevProps, presState) {
        if ((prevProps.user.otp_enabled !== this.props.user.otp_enabled) && !this.props.user.otp_enabled) {
            this.handleTwoFactor()
        }
    }
    handleTwoFactor = async () => {
        const res = await requestOTP();
        this.props.userAction.requestOtp(res.data);
    }
    renderBody = () => {
        const { otp, email, otp_enabled } = this.props.user
        let APP_TITLE = 'HollaEx'
        return (
            otp_enabled
                ?
                <div className="otp_form-wrapper">
                    <div className="otp_form-section-wrapper border-none">
                        <div className="otp_form-section-title">
                            <span>Enter your 6-digit authentication code</span>
                        </div>
                        <WrappedOTPForm />
                    </div>
                </div>
                :
                <div className="otp_form-wrapper">
                    <div className="otp_form-section-wrapper">
                        <div className="otp_form-section-title">
                            <span>Scan</span>
                        </div>
                        <div className="otp_form-section-text">
                            Scan the qrcode below with Google Authenticator or Authy to automatically setup two-factor authentication in your device.
                    </div>
                        <div className="d-flex justify-content-center otp_form-section-content">
                            <div className="qr-code-wrapper d-flex justify-content-center align-items-center">
                                <QRCode
                                    value={`otpauth://totp/${APP_TITLE}-${email}?secret=${otp && otp.secret}&issuer=${APP_TITLE}`}
                                    size={150}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="otp_form-section-wrapper">
                        <div className="otp_form-section-title">
                            <span>Manual</span>
                        </div>
                        <div className="otp_form-section-text">
                            If you have problems scanning this, you can manually enter the code below
                        <br />
                        You can store this code securely to recover your 2FA in case you change or lose your mobile phone in future.
                    </div>
                        <div className="otp_form-section-content otp_secret">{otp && otp.secret}</div>
                    </div>
                    <div className="otp_form-section-wrapper">
                        <div className="otp_form-section-title">
                            <span>Enter your 6-digit authentication code</span>
                        </div>
                        <WrappedOTPForm />
                    </div>
                </div>
        )
    }
    render() {
        return (
            <Wrapper>{this.renderBody()}</Wrapper>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    userAction: bindActionCreators(UserAction, dispatch)
});

export default connect(null, mapDispatchToProps)(TwoFactor);